import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { loginCorporate } from 'actions/corporate/login'

import {
  isPostingCorporateLogin,
  getCorporateLoginData,
  getCorporateLoginErrorDescription
} from 'selectors/corporate/login'
import { mapMediaType } from 'selectors/mediaType'
import { getCorporateLoginToken } from 'selectors/corporate/login'

import { parseToGeneralLanguage } from 'localization/helpers'
import { isEmpty } from 'helpers/utils'
import { getKeysWithIndex } from 'helpers/translations'

import CorporateAgreementsLogin from 'containers/corporate-agreements/login-container/login'
import AgreementRequestForm from 'containers/corporate-agreements/login-container/agreement-request'
import RefundTicket from 'containers/corporate-agreements/login-container/refund-request'

import Tabs from 'components/tabs-new'
import List from 'components/list'
import { TransitionLoader } from 'components/loaders'
import SearchBox from 'components/search-box'
import { loadRecaptcha } from 'components/recaptchaV2'

import NAMESPACES from 'localization/constants/namespaces'

import { LoginWrapper, InfoText, InfoTextTitle, FormContainer, SearchboxWrapper } from './styled'

import PageContentWrapper from '../components/page-content-wrapper'

const CorporateAgreementsContainer = props => {
  const [showSearchbox, setSearchbox] = useState(false)
  const {
    t,
    i18n: { language }
  } = useTranslation(NAMESPACES.CORPORATE_AGREEMENTS)

  useEffect(() => {
    loadRecaptcha(parseToGeneralLanguage(language))
  }, [])

  useEffect(() => {
    if (!isEmpty(props.loginData)) {
      setSearchbox(true)
    }
  }, [props.loginData])

  const submitLogin = values => props.loginCorporate(values)

  const getContent = () => {
    if (showSearchbox) {
      return (
        <SearchboxWrapper>
          <SearchBox />
        </SearchboxWrapper>
      )
    }

    return (
      <LoginWrapper>
        <CorporateAgreementsLogin
          title={t('agreements.login.title')}
          handleLogin={submitLogin}
          error={props.loginErrorMessage}
        />
      </LoginWrapper>
    )
  }

  if (props.isPostingLogin || props.isFetchingLanding) {
    return <TransitionLoader />
  }

  const info = getKeysWithIndex('agreements.info-text.details', 4).map(trKey => t(trKey))

  return (
    <PageContentWrapper top={getContent()}>
      <InfoText>
        <InfoTextTitle>{t('agreements.info-text.title')}</InfoTextTitle>
        <List keys={info || []} />
      </InfoText>
      <Tabs
        tabs={[{ title: t('agreements.tabs.request') }, { title: t('agreements.tabs.refund') }]}
        content={[
          <FormContainer key={'form_agreement'}>
            <AgreementRequestForm />
          </FormContainer>,
          <FormContainer key={'form_return'}>
            <RefundTicket />
          </FormContainer>
        ]}
      />
    </PageContentWrapper>
  )
}

const mapDispatchToProps = {
  loginCorporate
}

const mapStateToProps = state => ({
  isPostingLogin: isPostingCorporateLogin(state),
  loginData: getCorporateLoginData(state),
  corporateToken: getCorporateLoginToken(state),
  loginErrorMessage: getCorporateLoginErrorDescription(state),
  mediaType: mapMediaType(state)
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CorporateAgreementsContainer)
)
